/* eslint-disable jsx-a11y/anchor-is-valid */
import { useEffect } from 'react';
import { Outlet } from 'react-router-dom';

const CustomerPanelLayout = () => {
  useEffect(() => {
    const root = document.getElementById('root');
    if (root) {
      root.style.height = '100%';
    }
    return () => {
      if (root) {
        root.style.height = 'auto';
      }
    };
  }, []);

  return (
    <>
      <div className='header-wraper header h-90px h-lg-90px'>
        <div className='toolbar d-flex align-items-stretch'>
          <div className='container-fluid py-6 py-lg-0 justify-content-between'>
            <div className='d-flex justify-content-between cp-header'>
              <div className='logo-box order-2 order-lg-1'>
                <div className='d-flex justify-content-center align-items-center'>
                  <a href='#' className='brand-logo me-5'>
                    <img alt='Logo' src='/media/logos/logo.jpeg' className='h-80px h-lg-80px' />
                  </a>
                </div>
              </div>

              {/* <div className='menu-bar'>
                                <div  className='app-header-menu h-100 d-flex align-items-center'>
                                    <ul className='cp-menu d-flex menu-rounded menu-column menu-row my-5 my-lg-0 align-items-stretch fw-semibold px-2 px-lg-0'>
                                        <li className='menu-item menu-lg-down-accordion me-0 me-lg-2'>
                                            <a href='#' className='menu-link'><span className='menu-title'>Home</span></a>
                                        </li>
                                        <li className='menu-item menu-lg-down-accordion me-0 me-lg-2'>
                                            <a href='#' className='menu-link'><span className='menu-title'>Navigation</span></a>
                                        </li>
                                        <li className='menu-item menu-lg-down-accordion me-0 me-lg-2'>
                                            <a href='#' className='menu-link'><span className='menu-title'>Navigation</span></a>
                                        </li>
                                        <li className='menu-item menu-lg-down-accordion me-0 me-lg-2'>
                                            <a href='#' className='menu-link'><span className='menu-title'>Navigation</span></a>
                                        </li>
                                    </ul>
                                </div>
                            </div> */}

              <nav className='navbar navbar-expand-lg menu-bar order-1 order-lg-2'>
                <button
                  className='navbar-toggler'
                  type='button'
                  data-toggle='collapse'
                  data-target='#navbarNavDropdown'
                  aria-controls='navbarNavDropdown'
                  aria-expanded='false'
                  aria-label='Toggle navigation'
                >
                  <span className='navbar-toggler-icon'></span>
                </button>
                <div className='collapse navbar-collapse app-header-menu' id='navbarNavDropdown'>
                  <ul className='cp-menu navbar-nav'>
                    <li className='menu-item  active'>
                      <a className='menu-link' href='#'>
                        <span className='menu-title'>Home</span>{' '}
                        <span className='sr-only'>(current)</span>
                      </a>
                    </li>
                    <li className='menu-item '>
                      <a className='menu-link' href='#'>
                        <span className='menu-title'>Features</span>
                      </a>
                    </li>
                    <li className='menu-item '>
                      <a className='menu-link' href='#'>
                        <span className='menu-title'>Pricing</span>
                      </a>
                    </li>
                    <li className='menu-item '>
                      <a className='menu-link' href='#'>
                        <span className='menu-title'>Navigation</span>
                      </a>
                    </li>
                  </ul>
                </div>
              </nav>

              <div className='user-name-login order-3'>
                <div className='d-flex flex-column h-100 justify-content-center align-items-end'>
                  <h1 className='text-dark fw-bolder fs-3 mb-0'>Vikas Patel</h1>
                  <a href='#' className='d-block logout'>
                    Logout
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className='d-flex flex-column flex-lg-row flex-column-fluid h-100'>
        {/* begin::Body */}
        <div className='d-flex flex-column flex-lg-row-fluid w-lg-50 p-10 justify-content-between'>
          <Outlet />
          {/* begin::Footer */}
          <div className='card d-flex flex-center flex-wrap px-5'>
            {/* begin::Links */}
            <div className='card-body d-flex fw-semibold text-primary fs-base'>
              <a href='#' className='px-5' target='_blank'>
                Terms
              </a>

              <a href='#' className='px-5' target='_blank'>
                Plans
              </a>

              <a href='#' className='px-5' target='_blank'>
                Contact Us
              </a>
            </div>
            {/* end::Links */}
          </div>
          {/* end::Footer */}
        </div>
        {/* end::Body */}
      </div>
    </>
  );
};

export { CustomerPanelLayout };
